var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "area_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    fontSize: 22,
    viewBox: "0 0 200 200"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".area_svg__st0{fill:#202425}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 71.8h-37.5c-1.8 0-3.2 1.5-3.2 3.2v25c0 1.8 1.5 3.2 3.2 3.2H150c1.8 0 3.2-1.5 3.2-3.2V75c0-1.8-1.4-3.2-3.2-3.2m-3.2 25h-31V78.2h31z",
    className: "area_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 153.2H150c1.8 0 3.2-1.5 3.2-3.2v-25c0-1.8-1.5-3.2-3.2-3.2h-37.5c-1.8 0-3.2 1.5-3.2 3.2v9.2H72v-56h15.5c1.8 0 3.2-1.5 3.2-3.2V50c0-1.8-1.5-3.2-3.2-3.2H50c-1.8 0-3.2 1.5-3.2 3.2v25c0 1.8 1.5 3.2 3.2 3.2h15.5v59.2c0 1.8 1.5 3.2 3.2 3.2h40.5v9.2c0 2 1.5 3.4 3.3 3.4m3.3-25h31v18.5h-31zM53.2 71.8V53.2h31v18.5h-31z",
    className: "area_svg__st0"
  })));
};
export default SvgArea;